<template>
  <div class="personal-home">
    <div class="card-list">
      <div
        class="card-box cursor-point"
        v-for="(item, index) in healthyCardList"
        :key="index"
        @click="showDeleteConfirm(item.recordId)"
        :style="cardnum(index,healthyCardList.length)"
      >
        <div class="region">淮南市卫生健康委员会</div>
        <div>
          <div class="user-name">{{ item.name }}</div>
          <div class="idCard">{{ item.idCard | idCardShield }}</div>
        </div>
        <div class="qrcode" ref="qrCodeUrl">
          <img src="@/assets/user-center/qrcode.png" alt />
        </div>
      </div>
      <div
        v-if="healthyCardList.length < 5"
        class="newcard-box cursor-point"
        @click="addNewCard"
        style="background:#FEFEFE"
      >
        <div class="add-new">
          <div>
            <icon-font style="font-size:48px;color:#C9C9C9;" type="icon-jiahao" />
          </div>
        </div>
        <div class="text">
          <div>请注册您的健康卡</div>
          <div>（您还可以添加{{ 5 - healthyCardList.length }}张健康卡）</div>
          <div style="font-size:10px">
            已有健康卡，
            <span style="color:#3385ED" @click.stop="openFast">快速绑定</span>
          </div>
        </div>
      </div>
    </div>
    <Register-card ref="zcBind"></Register-card>
    <Fast-bind ref="fastBind"></Fast-bind>
  </div>
</template>
<script>
import RegisterCard from "@/components/RegisterCard";
import FastBind from "@/components/FastBind";
import { deleteRecord } from "@/api/user-center";
export default {
  components: {
    RegisterCard,
    FastBind,
  },
  data() {
    let checkIdCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入身份证号码"));
      }
      let zz = /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/;
      if (!zz.test(value)) {
        callback(new Error("身份证号码格式错误"));
      } else {
        callback();
      }
    };
    return {
      healthyCardList: [],
      registerCard: false,
      fastBind1: false,
      visible: false,
      rules: {
        idCard: [
          {
            validator: checkIdCard,
            trigger: "blur",
          },
        ],
      },
      formInline: {
        idCard: "",
      },
    };
  },
  created(){
  },
  computed: {
    healthyCardListChange: function () {
      return this.$store.state.relationRecords;
    },
  },
  watch: {
    healthyCardListChange(n, m) {
      this.healthyCardList = n;
    },
  },
  mounted() {
    this.getUser();
  },
  methods: {
    // 计算3的余数
    cardnum(val,length){
      if(length<3) return  'marginRight:10px;'
      if(val%3!==2||val==0){
        return 'marginRight:10px;'
      }
      return ''
    },
    getUser() {
      this.$store
        .dispatch("setRelationRecords")
        .then(async () => {
          this.healthyCardList = this.$store.state.relationRecords;
        })
        .catch(() => {});
    },
    addNewCard() {
      this.$refs.zcBind.onShow();
    },
    openFast() {
      this.$refs.fastBind.onShow();
    },
    showDeleteConfirm(recordId) {
      var that = this;
      this.$confirm({
        title: "你是否要解绑此卡?",
        content: "",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        async onOk() {
          await deleteRecord({ recordId });
          that.getUser();
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.personal-home {
  width: 100%;
  padding: 40px 70px 250px;
  border: 1px solid #e8e8e8;
  margin-bottom: 20px;
  .card-list {
    display: flex;
    // justify-content: space-between;
    width: 100%;
    flex-wrap: wrap;
    .card-box {
      width: 233px;
      height: 129px;
      background: url("~@/assets/user-center/healthy-card.png") no-repeat center
        center;
      background-size: 100% 100%;
      position: relative;
      letter-spacing: 0;
      font-family: PingFang SC;
      border-radius: 10px;
      border: 1px solid #e8e8e8;
      margin-bottom: 80px;
      padding: 15px 13px 22px 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .region {
        font-size: 8rpx;
        transform: scale(0.8);
        transform-origin: center left;
        font-weight: bold;
        color: #202020;
      }
      .user-name {
        font-size: 13px;
        font-weight: bold;
        color: #2b2b2b;
      }
      .idCard {
        font-weight: 500;
        color: #2b2b2b;
      }
      .qrcode {
        width: 59px;
        height: 59px;
        position: absolute;
        top: 40px;
        right: 13px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .newcard-box {
      width: 233px;
      height: 129px;
      background: url("~@/assets/user-center/healthy-card.png") no-repeat center
        center;
      background-size: 100% 100%;
      letter-spacing: 0;
      font-family: PingFang SC;
      border-radius: 10px;
      border: 1px solid #e8e8e8;
      margin-bottom: 80px;
      padding: 15px 13px 22px 10px;
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      .add-new {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #9a9a9a;
      }
    }
  }
}
/deep/ .ant-modal-body {
  padding: 0;
}

.text {
  text-align: center;
  position: relative;
  top: 30px;
  // transform: scale(0.9);
  font-size: 10px;
}
</style>
